<template>
	<div v-bottom="nextPage" class="videos-list">
		<VideosCardH :type="0" v-for="(item,index) in videosList" :key="index" :videosInfo="item" />
		<div v-if="endPage" class="scroll-end"></div>
	</div>
</template>

<script>
import VideosCardH from "./child/videosCardH.vue";
export default {
	components: {
		VideosCardH,
	},

	data() {
		return {
			params: {
				type:0,
				pageNo: 1,
				pageSize: 10,
			},
			pages:0,
			videosList: [],
		};
	}, 

	computed:{
		endPage(){
			return this.pages&&this.pages==this.params.pageNo;
		},
	},

	mounted() {
		this.getVideosList();
	},

	methods: {
		nextPage(){
			if(this.endPage) return
			this.params.pageNo++;
			this.getVideosList();
			console.log('nextPage');
		},
		async getVideosList() {
			try {
				const {success,message,result} = await this.$http.get(`h5/general/listVideoCollection`,{params:this.params});
				if (!success) throw new Error(message);
				this.pages = result.pages;
				this.videosList = this.videosList.concat(result.records);
			} catch (error) {
				console.log("getVideoList", error?.message);
			}
		},
	},
};
</script>

<style scoped lang="less">
.videos-list {
	height: 100%;
	overflow-y: auto;
	padding: 17 / @rem;
}
</style>
